if (!customElements.get("bundle-button")) {
  customElements.define(
    "bundle-button",
    class BundleButton extends HTMLElement {
      constructor() {
        super();

        this.bundleIds = this.dataset.bundleIds;
        this.sideCart = document.querySelector("side-cart");

        this.init();
      }

      init() {
        this.addEventListener("click", this.addBundleProd.bind(this));
      }

      async addBundleProd() {
        if (!this.bundleIds) return;

        try {
          this.classList.add("inprogress");

          const bundles = this.bundleIds.split(",");
          const items = bundles
            .filter((bundle) => bundle && bundle !== "")
            .map((bundle) => {
              return {
                quantity: 1,
                id: bundle,
                properties: {},
              };
            });
          await this.sideCart.addItemsToCart(items);
          setTimeout(this.classList.remove("inprogress"), 1000);
        } catch (err) {
          console.error(err);
        }
      }
    }
  );
}
